import { ref } from "vue";

/**
 * The `now` that the whole gantt is drawn relative to.
 *
 * Everything downstream derives from this ref, so the chart drifts left on its
 * own as time passes — which is what a relative axis should do, and is genuinely
 * useful: a task creeping toward the now-line is visible. Frozen during a drag
 * so the ground does not move under the cursor.
 */
export const nowMs = ref(Date.now());

let frozen = 0;

export function freezeClock(): void {
  frozen++;
}

export function thawClock(): void {
  frozen = Math.max(0, frozen - 1);
}

window.setInterval(() => {
  if (frozen === 0) nowMs.value = Date.now();
}, 30_000);
